export const ADMIN_AFFILIATE_TRACKERS_SETTINGS_MAIN_ROUTE_NAME = Symbol('admin.affiliates.approved.trackers-settings.main');
export const TRANSLATION_GROUP_AFFILIATES_TRACKERS_SETTINGS_MAIN = Symbol('admin.affiliates.approved.trackers-settings.main');

export const AFFILIATE_GET_TRACKERS_SETTINGS_QUERY = 'affiliate.get-trackers-settings';
export const AFFILIATE_GET_TRACKERS_SETTINGS_API_URL = 'admin/affiliates/:id/show_tracker_settings';

export const AFFILIATE_SAVE_TRACKERS_SETTINGS_MUTATION = 'affiliate.save-trackers-settings';
export const AFFILIATE_SAVE_TRACKERS_SETTINGS_API_URL = 'admin/affiliates/:id';
